module.exports = __webpack_public_path__ + "static/qs_screenshot-372623440aef3cc90d60c232f12b155f.png";